import { css, type Theme } from '@emotion/react';

import { LESSON_RESOURCE_PICTURE_ASPECT_RATIO } from '@didaskill/domain/lessons/constants';

import { SIZES } from './constants';

export const container = (pictureHref?: string) => (theme: Theme) =>
  css`
  &.${SIZES.SMALL} {
    min-width: 150px;
  }

  &.${SIZES.MEDIUM} {
    min-width: 235px;
  }

  &.${SIZES.LARGE} {
    min-width: 400px;
  }

  aspect-ratio: ${LESSON_RESOURCE_PICTURE_ASPECT_RATIO};
  background-color: ${theme.colors.primary[15]};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.gray[100]};
  border-radius: 4px;
  position: relative;

  ${
    pictureHref &&
    css`
    background-image: url(${pictureHref});
    background-position: center;
    background-size: cover;
  `
  }
`;
